import React from 'react'
import { Button } from '@material-ui/core'
import { COMPONENT_PERMS } from '../../../Authz/types'
import { CreateAuthz } from '../../../Authz/containers/AuthzHocCreator'
import { COLORES } from '../../../../config/colores'

const ButtonNominacion = CreateAuthz(COMPONENT_PERMS['/cupos/nominacion'], false, false)(Button)
const ButtonModificiacion = CreateAuthz(COMPONENT_PERMS['/cupos/modificacion'], false, false)(Button)
const ButtonBloqueo = CreateAuthz(COMPONENT_PERMS['/cupos/bloqueo'], false, false)(Button)

export function OperacionesCupoAsignadoView (props) {
  const { cupo } = props

  return (
    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nonwrap' }}>
      <ButtonModificiacion style={{ color: COLORES.green.medium }} onClick={() => props.openDialogModificacion(cupo)}>
          EDITAR
      </ButtonModificiacion>
      <ButtonModificiacion style={{ color: COLORES.red.medium }} onClick={() => props.deleteCupo(cupo)}>
          ELIMINAR
      </ButtonModificiacion>
      {cupo.habilitado === 'Habilitado' && (
        <ButtonBloqueo style={{ color: COLORES.blue.medium }} onClick={() => props.bloquearCupos(cupo, false)}>
            BLOQUEAR
        </ButtonBloqueo>
      )}
      {cupo.habilitado !== 'Habilitado' && (
        <ButtonBloqueo style={{ color: COLORES.blue.medium }} onClick={() => props.cambiarEstadoHabilitadoCupo(cupo, true)}>
            DESBLOQUEAR
        </ButtonBloqueo>
      )}
      {cupo.tipo === 'Nominable' && cupo.habilitado === 'Habilitado' && cupo.cantidadDisponible > 0 && (
        <ButtonNominacion style={{ color: COLORES.orange.medium }} onClick={() => props.openDialogNominacion(cupo)}>
            NOMINAR
        </ButtonNominacion>
      )}
    </div>
  )
}
